const pricing = {
  // HeroSection
  'pricing.hero.homeLink': 'ホーム',
  'pricing.hero.currentPage': '料金・特典',
  'pricing.hero.imgAlt': '受講料に含まれる白手袋と教科書を格調高く配置した静物',

  // breadcrumb (page.tsx)
  'pricing.breadcrumb.home': 'ホーム',
  'pricing.breadcrumb.current': '料金・特典',

  // PricingTable
  'pricing.table.label': 'TUITION TABLE',
  'pricing.table.title': '受講料一覧',
  'pricing.table.titleEn': 'Course Tuition',
  'pricing.table.lead': '受講料には、授業料だけでなく、教材費・実習費・受講特典・修了試験料まで含まれています。学びに必要なものを、まとめてご用意しています。全コースの受講料は税込表示です。少人数制で学ぶ日本の執事学校として、コースごとの学費・執事の費用を一覧でご確認いただけます。',
  'pricing.table.colItem': '項目',
  'pricing.table.rowDuration': '期間',
  'pricing.table.rowDays': '日数',
  'pricing.table.rowHours': '時間数',
  'pricing.table.rowSchedule': '開校時期',
  'pricing.table.rowPrice': '受講料（税込）',
  'pricing.table.taxIncluded': '（税込）',
  'pricing.table.courseListLink': 'コース一覧',
  'pricing.table.courseListNote': '各コースの詳しい内容は',
  'pricing.table.courseListNoteSuffix': 'をご覧ください',

  // WhatIncluded
  'pricing.included.label': "WHAT'S INCLUDED",
  'pricing.included.title': '料金に含まれるもの',
  'pricing.included.titleEn': 'All-Inclusive Tuition',
  'pricing.included.lead': '受講料には、授業料だけでなく学びに必要なすべてが含まれています。教材費・実習費・受講特典・修了試験料まで、追加のご負担は原則ありません。執事養成学校としての受講環境に必要な経費も、学費の中でまとめてご案内しています。',
  'pricing.included.additionalTitle': '別途ご負担いただくもの',
  'pricing.included.imgAlt': '白手袋・教科書・オリジナルエプロンを並べた受講特典の執事道具セット',
  'pricing.included.imgCaption': 'コース受講特典としてお渡しする執事道具一式',

  // PaymentMethod
  'pricing.payment.label': 'PAYMENT',
  'pricing.payment.title': 'お支払い方法',
  'pricing.payment.bankTitle': '銀行振込（一括払いのみ）',
  'pricing.payment.bankInfo1': '受講料は銀行振込による一括払いです。',
  'pricing.payment.bankInfo2': 'お振込先の口座情報は、お申込み後にお送りする受講契約のご案内に記載してお知らせします。',
  'pricing.payment.deadlineLabel': '支払期限',
  'pricing.payment.warningNote': '分割払い・クレジットカードはご利用いただけません。お振込時の手数料はお客様のご負担となりますので、あらかじめご了承ください。',

  // TransferDiscount
  'pricing.transfer.label': 'TRANSFER BENEFIT',
  'pricing.transfer.title': '編入優遇',
  'pricing.transfer.taxNote': '税込',
  'pricing.transfer.consultLink': '個別相談',
  'pricing.transfer.consultNote': '編入をご検討の方は',
  'pricing.transfer.consultNoteSuffix': 'にてお気軽にご確認ください',

  // MoreDetails
  'pricing.more.label': 'DETAILS',
  'pricing.more.title': 'もっと詳しく',
  'pricing.more.titleEn': 'Learn More',
  'pricing.more.lead': '料金のより詳しい内訳や、受講特典、修了証・認定資格の詳細については、各ページをご覧ください。ご不明な点は個別相談にて丁寧にご説明いたします。',
  'pricing.more.imgAlt': '実習でテーブルセッティングを指導する講師と見守る受講生',
  'pricing.more.imgCaption': 'テーブルセッティングの手順を一つずつ確認しながら指導する講師の様子',
  'pricing.more.arrowLabel': '詳しく見る',

  // CTASection
  'pricing.cta.label': 'NEXT STEP',
  'pricing.cta.title': 'まずは資料請求から',
  'pricing.cta.lead': '無料の資料請求で、コースの詳細やアカデミーの理念をまとめた資料をお届けします。ご不明な点は個別相談にて丁寧にご説明いたします。',
  'pricing.cta.note': '※ご相談はオンラインでも承ります',
  'pricing.cta.brochureBtn': '資料請求はこちら（無料）',
  'pricing.cta.consultBtn': '個別相談を予約する',
  'pricing.cta.corporateNote': '企業・団体でのご検討は',
  'pricing.cta.corporateLink': '法人研修（出張型）へ',

  // FAQSection
  'pricing.faq.label': 'FAQ',
  'pricing.faq.title': 'よくあるご質問',
  'pricing.faq.titleEn': 'Frequently Asked Questions',
  'pricing.faq.contactNote': 'その他のご質問は',
  'pricing.faq.contactLink': 'お問い合わせ',
  'pricing.faq.contactNoteSuffix': 'よりお寄せください',

  // RelatedPages
  'pricing.related.label': 'LEARN MORE',
  'pricing.related.title': '関連ページ',
  'pricing.related.titleEn': 'Explore Further',
  'pricing.related.arrowLabel': '詳しく見る',

  // footer
  'pricing.footer.lastUpdated': '最終更新: 2026年6月13日',
  'pricing.backToTop.ariaLabel': 'ページの先頭へ戻る',
};

export default pricing;
